import { formatPrice } from './formats'

const PRICE_TEXT_UNTIL_SHOP_ITEMS_LOAD = '\u00a0'

const PRICE_PLACEHOLDER_PREFIX = '${'
const PRICE_PLACEHOLDER_SUFFIX = '_PRICE}'

export const containsPrice = (textContent) => {
  if (!textContent) return false

  if (Array.isArray(textContent)) {
    return textContent.some(t => containsPricePlaceholder(t))
  } else {
    return containsPricePlaceholder(textContent)
  }
}

export const replacePrice = (textContent, namedPrices) => {
  if (!textContent) return textContent

  if (Array.isArray(textContent)) {
    return textContent.map(t => replacePricePlaceholder(t, namedPrices))
  } else {
    return replacePricePlaceholder(textContent, namedPrices)
  }
}

export const clearPrice = (textContent) => {
  if (!textContent) return textContent

  if (Array.isArray(textContent)) {
    return textContent.map(t => clearPricePlaceholders(t))
  } else {
    return clearPricePlaceholders(textContent)
  }
}

const containsPricePlaceholder = (str) => {
  return typeof str === 'string' &&
    str.includes(PRICE_PLACEHOLDER_PREFIX) &&
    str.includes(PRICE_PLACEHOLDER_SUFFIX)
}

const replacePricePlaceholder = (str, namedPrices) => {
  if (!str || typeof str !== 'string') {
    return str
  }

  namedPrices
    .filter(n => str.includes(buildItemPricePlaceholder(n)))
    .forEach(n => {
      str = str.replaceAll(buildItemPricePlaceholder(n), formatPrice(n.price))
    })

  return str
}

const clearPricePlaceholders = (str) => {
  str
    .match(/\${\w*}/g)
    .forEach(p => str = str.replaceAll(p, PRICE_TEXT_UNTIL_SHOP_ITEMS_LOAD))

  return str
}

const buildItemPricePlaceholder = (namedPrice) => {
  return PRICE_PLACEHOLDER_PREFIX + namedPrice.name + PRICE_PLACEHOLDER_SUFFIX
}

